import ActionTypes from '../constants/ActionTypes';

const fetchListReportData = (listId) => ({
  type: ActionTypes.LIST_REPORT_DATA_FETCH,
  payload: {
    listId,
  },
});

fetchListReportData.success = (listId, item) => ({
  type: ActionTypes.LIST_REPORT_DATA_FETCH__SUCCESS,
  payload: {
    listId,
    item,
  },
});

fetchListReportData.failure = (listId, error) => ({
  type: ActionTypes.LIST_REPORT_DATA_FETCH__FAILURE,
  payload: {
    listId,
    error,
  },
});

const upsertListReportData = (listId, data) => ({
  type: ActionTypes.LIST_REPORT_DATA_UPSERT,
  payload: {
    listId,
    data,
  },
});

upsertListReportData.success = (item) => ({
  type: ActionTypes.LIST_REPORT_DATA_UPSERT__SUCCESS,
  payload: {
    item,
  },
});

upsertListReportData.failure = (listId, error) => ({
  type: ActionTypes.LIST_REPORT_DATA_UPSERT__FAILURE,
  payload: {
    listId,
    error,
  },
});

const completeListReportData = (listId) => ({
  type: ActionTypes.LIST_REPORT_DATA_COMPLETE,
  payload: {
    listId,
  },
});

completeListReportData.success = (item) => ({
  type: ActionTypes.LIST_REPORT_DATA_COMPLETE__SUCCESS,
  payload: {
    item,
  },
});

completeListReportData.failure = (listId, error) => ({
  type: ActionTypes.LIST_REPORT_DATA_COMPLETE__FAILURE,
  payload: {
    listId,
    error,
  },
});

const updateListReportEmployeeLevels = (listId, data) => ({
  type: ActionTypes.LIST_REPORT_DATA_EMPLOYEE_LEVELS_UPDATE,
  payload: {
    listId,
    data,
  },
});

updateListReportEmployeeLevels.success = (item) => ({
  type: ActionTypes.LIST_REPORT_DATA_EMPLOYEE_LEVELS_UPDATE__SUCCESS,
  payload: {
    item,
  },
});

updateListReportEmployeeLevels.failure = (listId, error) => ({
  type: ActionTypes.LIST_REPORT_DATA_EMPLOYEE_LEVELS_UPDATE__FAILURE,
  payload: {
    listId,
    error,
  },
});

export default {
  fetchListReportData,
  upsertListReportData,
  completeListReportData,
  updateListReportEmployeeLevels,
};
